// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartControlSelect-modulelist__x1bDF SelectDropdownList-moduleSelectDropdownList__xvHZa SelectDropdown-moduleSelectDropdown__s9tE2";
var _2 = "BirdviewChartControlSelect-moduleselect__QiIZp Select-moduleSelect__MROu3";
export { _1 as "list", _2 as "select" }
